import { defineComponent as _defineComponent } from 'vue';
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AsyncButton',
    props: {
        icon: null,
        title: { default: "" },
        disabled: { type: Boolean },
        loadingTitle: { default: "Loading..." },
        size: { default: "md" },
        action: null,
        variant: { default: "link" }
    },
    setup(__props) {
        const props = __props;
        const loading = ref(false);
        async function onClick() {
            loading.value = true;
            await props.action();
            loading.value = false;
        }
        return { __sfc: true, props, loading, onClick, FontAwesomeIcon, BButton };
    }
});
